export enum DeviceFileType {
  MEASURE = 'Measures',
  STATE = 'State',
  ALARM = 'Alarm'
}
